import * as actions from "../constants/actionTypes";
export const INITIAL_STATE = {
    loader: false,
    label: "",
};
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actions.SHOW_APP_LOADER:
            return {
                ...state,
                loader: true,
                label: action.payload ? action.payload : "",
            }
        case actions.HIDE_APP_LOADER:
            return {
                ...state,
                loader: false,
                label: "",
            }
        default:
            return state;
    }
};
